import { Box, Card, CardContent, Typography } from '@mui/material';
import { FC, PropsWithChildren, ReactNode } from 'react';

type Props = {
  icon: ReactNode;
  title: ReactNode;
  subtext: ReactNode;
};

const PersonaPrerequisite: FC<Props> = ({ title, subtext, icon }: PropsWithChildren<Props>) => {
  return (
    <Card variant="outlined">
      <CardContent sx={{ display: 'flex', alignItems: 'center' }}>
        {icon}
        <Box display="flex" flexDirection="column" ml={3}>
          <Typography variant="body1">{title}</Typography>
          <Typography variant="body2" color="textSecondary" mt={1}>
            {subtext}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export { PersonaPrerequisite };
